<template>
  <el-dialog
    :class="form.topicType == 1 ? 'dialog' : 'dialog active'"
    title="新增考核题"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form ref="form" :model="form" label-width="100px" style="padding:10px;">
      <el-form-item label="问题类型：">
        <el-radio
          size="mini"
          v-model="form.topicType"
          :label="1"
          border
          >选择题</el-radio
        >
        <el-radio
          size="mini"
          v-model="form.topicType"
          :label="2"
          border
          >判断题</el-radio
        >
      </el-form-item>
      <el-form-item label="问题：">
        <el-input
          placeholder="请输入问题"
          v-model.trim="form.questionContent"
        ></el-input>
      </el-form-item>
      <template v-if="form.topicType == 1">
        <el-form-item label="A：">
          <el-input placeholder="请输入A选项" v-model.trim="answerA"></el-input>
        </el-form-item>
        <el-form-item label="B：">
          <el-input placeholder="请输入B选项" v-model.trim="answerB"></el-input>
        </el-form-item>
        <el-form-item label="C：">
          <el-input placeholder="请输入C选项" v-model.trim="answerC"></el-input>
        </el-form-item>
        <el-form-item label="D：">
          <el-input placeholder="请输入D选项" v-model.trim="answerD"></el-input>
        </el-form-item>
        <el-form-item label="正确答案：">
          <div>
            <el-radio v-model="form.questionAnswerCorrect" label="A"
              >A</el-radio
            >
            <el-radio v-model="form.questionAnswerCorrect" label="B"
              >B</el-radio
            >
            <el-radio v-model="form.questionAnswerCorrect" label="C"
              >C</el-radio
            >
            <el-radio v-model="form.questionAnswerCorrect" label="D"
              >D</el-radio
            >
          </div>
        </el-form-item>
      </template>
      <template v-if="form.topicType == 2">
        <el-form-item label="正确答案：">
          <div>
            <el-radio v-model="form.questionAnswerCorrect" label="A"
              >正确</el-radio
            >
            <el-radio v-model="form.questionAnswerCorrect" label="B"
              >错误</el-radio
            >
          </div>
        </el-form-item>
      </template>
      <el-form-item label="本题分数">
        <el-input
          placeholder="请输入本题分数(只能是正整数)"
          v-model.trim="form.questionFraction"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="onSubmit"
          >确定</el-button
        >
        <el-button size="small" @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "SafetyPaperAdd",
  components: {},
  props: {
    addResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    questionOrder: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      form: {
        questionAnswerContent: "",
        questionAnswerCorrect: "",
        questionContent: "",
        questionFraction: "",
        questionOrder: "",
        topicType: 1
      },
      answerA: "",
      answerB: "",
      answerC: "",
      answerD: "",
      dialogVisible: false
    };
  },
  created() {},
  mounted() {},
  watch: {
    addResize: function(newVal, oldVal) {
      if (newVal) {
        this.dialogVisible = true;
        this.form.questionOrder = this.questionOrder;
      }
    }
  },
  computed: {},
  methods: {
    async add() {
      let req = this.form;
      this.loading = true;
      let res = await this.$Http.addSafePaperQuestion(req);
      this.loading = false;
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "添加成功！"
        });
        this.cancel();
        this.$emit("getList");
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    onSubmit() {
      if (this.form.questionContent == "") {
        this.$message("请输入问题！");
        return;
      }

      if (this.form.topicType == 1) {
        if (this.answerA == "") {
          this.$message("请输入A选项！");
          return;
        }
        if (this.answerB == "") {
          this.$message("请输入B选项！");
          return;
        }
        if (this.answerC == "") {
          this.$message("请输入C选项！");
          return;
        }
        if (this.answerD == "") {
          this.$message("请输入D选项！");
          return;
        }
      }

      if (this.form.questionAnswerCorrect == "") {
        this.$message("请选择正确答案！");
        return;
      }
      if (!/(^[1-9]\d*$)/.test(this.form.questionFraction)) {
        this.$message("请输入本题分数！");
        return;
      }
      if (this.form.topicType == 1) {
        this.form.questionAnswerContent =
          "A：" +
          this.answerA +
          "#" +
          "B：" +
          this.answerB +
          "#" +
          "C：" +
          this.answerC +
          "#" +
          "D：" +
          this.answerD;
      } else {
        this.form.questionAnswerContent = "A：正确" + "#" + "B：错误";
      }
      // console.log(this.form.questionAnswerContent);
      // return;
      this.add();
    },
    cancel() {
      this.form = {
        questionAnswerContent: "",
        questionAnswerCorrect: "",
        questionContent: "",
        questionFraction: "",
        questionOrder: this.questionOrder,
        topicType: 1
      };
      this.answerA = "";
      this.answerB = "";
      this.answerC = "";
      this.answerD = "";
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog {
  &.active {
    /deep/ .el-dialog__body {
      height: 300px;
    }
  }
  /deep/ .el-dialog__body {
    height: 500px;
  }
  .el-input {
    width: 100%;
  }
}
</style>
